module.exports = __webpack_public_path__ + "rupay-445db8f85632ff99a9ff.svg";